export default "https://statics.cloudfastin.top/static/v1.27.34/store/images/aliexpress1.png?6f2af396908cd8e81c44af2a1da64f04";